import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c615d71c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "x-modal x-modal__scrapepath"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 1,
  class: "x-modal__container"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "x-modal__header" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "选择视频目录")
], -1))
const _hoisted_5 = { class: "breadcrumbs" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "crumb-label" }, "全部", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " > ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["title", "onClick"]
const _hoisted_10 = { class: "crumb-label" }
const _hoisted_11 = {
  key: 0,
  class: "content-box"
}
const _hoisted_12 = ["data-tips"]
const _hoisted_13 = {
  key: 1,
  class: "disklist"
}
const _hoisted_14 = {
  key: 2,
  class: "loading-box"
}
const _hoisted_15 = {
  key: 0,
  class: "x-modal__footer"
}
const _hoisted_16 = { class: "sel-indicator-icon" }
const _hoisted_17 = { class: "sel-indicator-label" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确定", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "取消", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-close icon-close" }, null, -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 2,
  class: "x-modal__container"
}
const _hoisted_24 = { class: "x-modal__header" }
const _hoisted_25 = { class: "container-title" }
const _hoisted_26 = { class: "header-left header-left-menus" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "qh-icon-back" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = {
  key: 0,
  class: "header-right header-right-menus"
}
const _hoisted_30 = {
  key: 0,
  class: "content-box"
}
const _hoisted_31 = {
  key: 0,
  class: "breadcrumbs"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "crumb-label" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " > ", -1))
const _hoisted_35 = ["data-tips"]
const _hoisted_36 = {
  key: 2,
  class: "disklist"
}
const _hoisted_37 = {
  key: 2,
  class: "loading-box"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "exception-picture" }, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "x-modal__footer"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "确认选择", -1))

import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { throttle } from 'lodash'
import { isLargeViewPort } from '@remote/utils/base'
import { usePromisifyDialog } from '@shared/utils/dialog'
import { checkState } from '@remote/store/utils'
import { useMultiPathSelector } from '@remote/store/hezi-file/path-selector'
import SVGIcon from '@remote/components/SVGIcon.vue'
import Loading from '@remote/components/Loading.vue'
import ListItem from './list-item.vue'
import FileItem from './file-item.vue'
import DiskItem from './disk-item.vue'
import NetDiskItem from './net-disk-item.vue'
import GradientButton from '@remote/components/GradientButton.vue'
import type { INetDrives, IDiskPartitionItem } from '@remote/type/hezi'

interface IProps {
  mask?: boolean
  closeOnMaskClick?: boolean
  onConfirm: (paths: Array<{ id: string; path: string; diskName: string }>) => Promise<boolean>
}
interface IEmits {
  (e: 'dialog-close'): void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    mask: { type: Boolean, default: false },
    closeOnMaskClick: { type: Boolean, default: false },
    onConfirm: null
  },
  emits: ["dialog-close"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'dialog-close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { mask: boolean, closeOnMaskClick: boolean, onConfirm: (paths: Array<{ id: string; path: string; diskName: string }>) => Promise<boolean> }

function logs (..._args) {
  console.log('[目录选择器]', ..._args)
}





const { close } = usePromisifyDialog(emit)
const isMount = ref(true)
function onClose () {
  isMount.value = false
  setTimeout(() => {
    close(null)
  }, 300)
}

function onMaskClick () {
  if (!props.closeOnMaskClick) return
  onClose()
}

const selectorStore = useMultiPathSelector()
const isPC = ref(isLargeViewPort())
const onLayoutChange = throttle(() => {
  isPC.value = isLargeViewPort()
}, 300, { leading: true, trailing: true })
onMounted(() => {
  selectorStore.init()
  onLayoutChange()
  window.addEventListener('resize', onLayoutChange)
})
onBeforeUnmount(() => {
  window.removeEventListener('resize', onLayoutChange)
})

const {
  state: pagedata,
  // isSelectAll,
  enterDisk,
  switchCrumbs,
  back,
  back2chooseDisk,
  setSelectState,
  selectAll,
  selectNone,
  toggleSelectItem,
  enterFolder,
} = selectorStore
const pageTitle = computed(() => {
  return pagedata.crumbs.length ? '选择视频目录' : '选择磁盘'
})
const listType = computed(() => pagedata.crumbs.length ? 'folder' : 'disk')
const isError = computed(() => pagedata.dataStatus === 'error')
const isLoading = computed(() => pagedata.dataStatus === 'loading')
const isReady = computed(() => pagedata.dataStatus === 'ready')
const isSubmitting = ref(false)
const crumbs4pc = computed(() => {
  const crumbs = pagedata.crumbs.map((c, i) => {
    const isLastIndex = i === pagedata.crumbs.length - 1
    const id = c.id
    const name = c.name.length > 6 ? (c.name.slice(0, 6) + '...') : c.name
    const title = c.name
    return { id, name, title, clickable: !isLastIndex }
  })
  if (pagedata.crumbs.length <= 4) {
    return crumbs
  }
  const ellipsis = {
    id: 'ellipsis',
    name: '...',
    title: '',
    clickable: false,
  }
  return crumbs.slice(0, 2).concat([ellipsis], crumbs.slice(-2))
})

function onBack () {
  const isHandled = back()
  if (isHandled) return
  onClose()
}
function onCancelSelect () {
  setSelectState(false)
}
function onToggleSelectAll () {
  if (pagedata.isSelectAll) {
    selectNone()
  } else {
    selectAll()
  }
}

function onIndicatorClick () {
  if (pagedata.isSelectAll) {
    onCancelSelect()
  } else {
    setSelectState(true)
    onToggleSelectAll()
  }
}

function onBackToDiskList () {
  back2chooseDisk()
}

function onClickCrumbs (crumb) {
  if (pagedata.selecting) return
  switchCrumbs(crumb)
}

function onToggleSelect (file) {
  toggleSelectItem(file)
}

function onClickFileItem (file) {
  if (pagedata.selecting) {
    onToggleSelect(file)
  } else {
    enterFolder(file)
  }
}

function onSubmit () {
  if (isSubmitting.value) return
  if (checkState(true, false, false, false)) return
  const items = pagedata.selecteds.map(path => {
    const id = pagedata.currDiskType === 'net_drive' ? (pagedata.currDisk as INetDrives).url : (pagedata.currDisk as IDiskPartitionItem).uuid
    return {
      id,
      path,
      diskName: pagedata.currDiskName,
    }
  })
  isSubmitting.value = true
  props.onConfirm(items).then((isOK) => {
    if (typeof isOK === 'boolean' && isOK) {
      onClose()
    }
  }).finally(() => {
    isSubmitting.value = false
  })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (isMount.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (__props.mask)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "x-modal__mask",
                onClick: _withModifiers(onMaskClick, ["self"])
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true),
          (isPC.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", {
                  class: _normalizeClass(["x-modal__content", {
            'page__ready': _unref(isReady),
            'page__loading': _unref(isLoading),
            'page__error': _unref(isError),
          }])
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      key: "all_disk",
                      class: "crumb",
                      onClick: onBackToDiskList
                    }, _hoisted_8),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(crumbs4pc), (route, i) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: route.id || 'all',
                        title: route.title,
                        class: _normalizeClass(["crumb", { 'disabled': !route.clickable }]),
                        onClick: ($event: any) => (route.clickable && onClickCrumbs(route))
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(route.name), 1),
                        _createElementVNode("span", null, " >" + _toDisplayString(i === _unref(crumbs4pc).length - 1 ? '' : ' '), 1)
                      ], 10, _hoisted_9))
                    }), 128))
                  ]),
                  (_unref(isReady))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_unref(listType) === 'folder')
                          ? (_openBlock(), _createElementBlock("ul", {
                              key: 0,
                              class: _normalizeClass(["filelist", {
                'loading': _unref(pagedata).dataStatus === 'loading',
                'error': _unref(pagedata).dataStatus === 'error',
                'empty': _unref(pagedata).dataStatus === 'ready' && _unref(pagedata).currList.length === 0,
              }]),
                              "data-tips": _unref(pagedata).errorText
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).currList, (file) => {
                                return (_openBlock(), _createBlock(ListItem, {
                                  key: file.path,
                                  file: file,
                                  selecteds: _unref(pagedata).selecteds,
                                  selecting: _unref(pagedata).selecting,
                                  onClick: onClickFileItem,
                                  onSelect: onToggleSelect
                                }, null, 8, ["file", "selecteds", "selecting"]))
                              }), 128))
                            ], 10, _hoisted_12))
                          : _createCommentVNode("", true),
                        (_unref(listType) === 'disk')
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).diskList, (disk) => {
                                return (_openBlock(), _createBlock(DiskItem, {
                                  key: disk.uuid,
                                  disk: disk,
                                  onClick: _unref(enterDisk)
                                }, null, 8, ["disk", "onClick"]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).netDrives, (disk) => {
                                return (_openBlock(), _createBlock(NetDiskItem, {
                                  key: disk.url,
                                  disk: disk,
                                  onClick: _unref(enterDisk)
                                }, null, 8, ["disk", "onClick"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isLoading))
                    ? (_openBlock(), _createBlock(Loading, {
                        key: 1,
                        class: "loading-box"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["exception-picture", _unref(pagedata).errorType])
                        }, null, 2),
                        _createElementVNode("span", null, _toDisplayString(_unref(pagedata).errorText), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (!!_unref(pagedata).currList.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", {
                        class: "sel-indicator",
                        onClick: onIndicatorClick
                      }, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(SVGIcon, {
                            name: _unref(pagedata).isSelectAll ? 'checked-round' : _unref(pagedata).selecteds.length ? 'checkhalf-round' : 'uncheck-round'
                          }, null, 8, ["name"])
                        ]),
                        _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(pagedata).selecteds.length ? `已选${_unref(pagedata).selecteds.length}项` : '全选'), 1)
                      ]),
                      _createVNode(GradientButton, {
                        class: "submit-button",
                        disabled: isSubmitting.value || !_unref(pagedata).selecteds.length,
                        onClick: onSubmit
                      }, {
                        default: _withCtx(() => [
                          _hoisted_18
                        ]),
                        _: 1
                      }, 8, ["disabled"]),
                      _createElementVNode("button", {
                        class: "cancel-button",
                        onClick: onClose
                      }, _hoisted_20)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  class: "x-modal__close",
                  onClick: onClose
                }, _hoisted_22)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, _toDisplayString(_unref(pageTitle)), 1),
                  _createElementVNode("div", _hoisted_26, [
                    (!_unref(pagedata).selecting)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "close",
                          onClick: onBack
                        }, _hoisted_28))
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "selecting-label",
                          onClick: onCancelSelect
                        }, " 取消 "))
                  ]),
                  (_unref(pagedata).selecting)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                        _createElementVNode("span", {
                          class: "selecting-label",
                          onClick: onToggleSelectAll
                        }, _toDisplayString(_unref(pagedata).isSelectAll ? '取消全选' : '全选'), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["x-modal__content", {
            'page__ready': _unref(isReady),
            'page__loading': _unref(isLoading),
            'page__error': _unref(isError),
          }])
                }, [
                  (_unref(isReady))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        (_unref(pagedata).crumbs.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).crumbs, (route) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: route.id || 'all',
                                  class: "crumb",
                                  onClick: ($event: any) => (onClickCrumbs(route))
                                }, [
                                  _createElementVNode("span", _hoisted_33, _toDisplayString(route.name), 1),
                                  _hoisted_34
                                ], 8, _hoisted_32))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(listType) === 'folder')
                          ? (_openBlock(), _createElementBlock("ul", {
                              key: 1,
                              class: _normalizeClass(["filelist", {
                'loading': _unref(pagedata).dataStatus === 'loading',
                'error': _unref(pagedata).dataStatus === 'error',
                'empty': _unref(pagedata).dataStatus === 'ready' && _unref(pagedata).currList.length === 0,
              }]),
                              "data-tips": _unref(pagedata).errorText
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).currList, (file) => {
                                return (_openBlock(), _createBlock(FileItem, {
                                  key: file.path,
                                  file: file,
                                  selecteds: _unref(pagedata).selecteds,
                                  selecting: _unref(pagedata).selecting,
                                  onClick: onClickFileItem,
                                  onSelect: onToggleSelect
                                }, null, 8, ["file", "selecteds", "selecting"]))
                              }), 128))
                            ], 10, _hoisted_35))
                          : _createCommentVNode("", true),
                        (_unref(listType) === 'disk')
                          ? (_openBlock(), _createElementBlock("ul", _hoisted_36, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).diskList, (disk) => {
                                return (_openBlock(), _createBlock(DiskItem, {
                                  key: disk.uuid,
                                  disk: disk,
                                  onClick: _unref(enterDisk)
                                }, null, 8, ["disk", "onClick"]))
                              }), 128)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pagedata).netDrives, (disk) => {
                                return (_openBlock(), _createBlock(NetDiskItem, {
                                  key: disk.url,
                                  disk: disk,
                                  onClick: _unref(enterDisk)
                                }, null, 8, ["disk", "onClick"]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(isLoading))
                    ? (_openBlock(), _createBlock(Loading, {
                        key: 1,
                        class: "loading-box"
                      }))
                    : _createCommentVNode("", true),
                  (_unref(isError))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("span", null, _toDisplayString(_unref(pagedata).errorText), 1)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (!!_unref(pagedata).selecteds.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                      _createVNode(GradientButton, {
                        class: "submit-button",
                        disabled: isSubmitting.value,
                        onClick: onSubmit
                      }, {
                        default: _withCtx(() => [
                          _hoisted_40
                        ]),
                        _: 1
                      }, 8, ["disabled"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})